import { Config } from './config';
import { Util } from './util';
import { Cookie } from './cookie';
import AmountFormatter from '../../libraries/amount-formatter'

class NewEditForm {

    constructor() {
        this.CONFIG = new Config();
        this.AMOUNT_FORMATTER = new AmountFormatter();
        this.CONTACT_INDEX_ELM_ID = 'contactCntElm';
        this.TRANSACTION_INDEX_ELM_ID = 'transactionCntElm';
        this.CONTENT_INDEX_ELM_ID = 'contentCntElm';
        this.NEW_EDIT_FORM_NAME = 'newEditForm';
        this.NEW_EDIT_FORM = document.forms[this.NEW_EDIT_FORM_NAME];
        this.NEW_EDIT_FORM_STORE_ID = this.NEW_EDIT_FORM['complaint[store_id]'];
        this.NEW_EDIT_FORM_SHOP_ID = this.NEW_EDIT_FORM['complaint[shop_id]'];
        this.NEW_EDIT_FORM_USERNAME = this.NEW_EDIT_FORM['complaint[username]'];
        this.NEW_EDIT_FORM_DEADLINE = this.NEW_EDIT_FORM['complaint[deadline]'];
        this.NEW_EDIT_FORM_STATUS_CLASSIFICATION = this.NEW_EDIT_FORM['complaint[status_classification]'];
        this.NEW_EDIT_FORM_STATUS = this.NEW_EDIT_FORM['complaint[status]'];
        this.NEW_EDIT_FORM_NOTIFICATION_TYPE = this.NEW_EDIT_FORM['complaint[notification_type]'];
        this.NEW_EDIT_FORM_CONTACTS_BOX_CLASS_NAME = 'complaintContactsBox';
        this.NEW_EDIT_FORM_ADD_CONTACTS_BTN = this.NEW_EDIT_FORM['addContactsBtn'];
        this.NEW_EDIT_FORM_INQUIRY_DATE_DATASET = 'inquiry_date_field';
        this.NEW_EDIT_FORM_INQUIRY_DATE = this.NEW_EDIT_FORM['complaint[complaint_contacts_attributes][0][inquiry_date]'];
        this.NEW_EDIT_FORM_INQUIRY_SOURCE_TYPE_DATASET = 'inquiry_source_type_field';
        this.NEW_EDIT_FORM_INQUIRY_SOURCE_TYPE = this.NEW_EDIT_FORM['complaint[complaint_contacts_attributes][0][inquiry_source_type]'];
        this.NEW_EDIT_FORM_CONTACTS_DATASET = 'contacts_field';
        this.NEW_EDIT_FORM_CONTACTS = this.NEW_EDIT_FORM['complaint[complaint_contacts_attributes][0][contacts]'];
        this.NEW_EDIT_FORM_CONTENTS_BOX_CLASS_NAME = 'complaintContentsBox';
        this.NEW_EDIT_FORM_ADD_CONTENTS_BTN = this.NEW_EDIT_FORM['addContentsBtn'];
        this.NEW_EDIT_FORM_TRANSACTION_AREA_CLASS_NAME = 'complaintTransactionArea';
        this.NEW_EDIT_FORM_TRANSACTIONS_BOX_CLASS_NAME = 'complaintTransactionsBox';
        this.NEW_EDIT_FORM_ADD_TRANSACTION_CARDS_BTN = this.NEW_EDIT_FORM['addTransactionCardsBtn'];
        this.NEW_EDIT_FORM_ADD_TRANSACTIONS_BTN = this.NEW_EDIT_FORM['addTransactionsBtn'];
        this.NEW_EDIT_FORM_TRANSACTION_CODE_DATASET = 'transaction_code_field';
        this.NEW_EDIT_FORM_TRANSACTION_CODE = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][transaction_code]'];
        this.NEW_EDIT_FORM_TRANSACTION_DATE_DATASET = 'transaction_date_field';
        this.NEW_EDIT_FORM_TRANSACTION_DATE = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][transaction_date]'];
        this.NEW_EDIT_FORM_AMOUNT_DATASET = 'amount_field';
        this.NEW_EDIT_FORM_AMOUNT = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][amount]'];
        this.NEW_EDIT_FORM_CARD_NUMBER_PREFIX_DATASET = 'card_number_prefix_field';
        this.NEW_EDIT_FORM_CARD_NUMBER_PREFIX = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][card_number_prefix]'];
        this.NEW_EDIT_FORM_CARD_NUMBER_SUFFIX_DATASET = 'card_number_suffix_field';
        this.NEW_EDIT_FORM_CARD_NUMBER_SUFFIX = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][card_number_suffix]'];
        this.NEW_EDIT_FORM_BRAND_ID_DATASET = 'brand_id_field';
        this.NEW_EDIT_FORM_BRAND_ID = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][brand_id]'];
        this.NEW_EDIT_FORM_ACTION_REQUIRED_FLAG_DATASET = 'action_required_flag';
        this.NEW_EDIT_FORM_ACTION_REQUIRED_FLAG = this.NEW_EDIT_FORM['complaint[complaint_transactions_attributes][0][action_required_flag]'];
        this.NEW_EDIT_FORM_CONTENT_DATASET = 'contents_field';
        this.NEW_EDIT_FORM_CONTENT = this.NEW_EDIT_FORM['complaint[complaint_contents_attributes][0][content]'];
        this.NEW_EDIT_FORM_FILES_BOX = document.getElementById('complaintFilesBox');
        this.NEW_EDIT_FORM_IMAGE = this.NEW_EDIT_FORM['complaint[files][]'];
        this.NEW_EDIT_FORM_NO_IMAGE = this.NEW_EDIT_FORM['no-image'];
        this.NEW_EDIT_FORM_UPLOADED_FILES_CLOSE_QUERY_SELECTOR = '[data="uploadedFilesClose"]';
        this.NEW_EDIT_FORM_UPLOADED_FILES_DOWNLOAD_QUERY_SELECTOR = '[data="uploadedFilesDownload"]';
        this.NEW_EDIT_FORM_UPLOADED_FILES_DATA_QUERY_SELECTOR = '[data-src="uploadedFilesData"]';
        this.NEW_EDIT_FORM_CONTACTS_DELETE_BTN_QUERY_SELECTOR = '[data="deleteContactsBtn"]';
        this.NEW_EDIT_FORM_TRANSACTION_CARDS_DELETE_BTN_QUERY_SELECTOR = '[data="deleteTransactionCardsBtn"]';
        this.NEW_EDIT_FORM_TRANSACTIONS_DELETE_BTN_QUERY_SELECTOR = '[data="deleteTransactionsBtn"]';
        this.NEW_EDIT_FORM_CONTENTS_DELETE_BTN_QUERY_SELECTOR = '[data="deleteContentsBtn"]';
        this.IS_JSON_AVAILABLE = true;
        this.FILE_MAX_NUM = 4;
        this.FILE_MAX_SIZE = 5000000;
        this.UPLOAD_FILES = new Array();
        this.TMP_DELETE_FILES = new Array();
    }


    GetRootElm() {
        return this.NEW_EDIT_FORM;
    }


    handleBefore(e) {
        if(e.target.name !== this.NEW_EDIT_FORM_NAME) {
           return;
        }
        if(this.UPLOAD_FILES.length === 0) {
            return;
        }
    }


    handleBeforeSend(e) {
        if(e.target.name !== this.NEW_EDIT_FORM_NAME) {
           return;
        }
        if(!this.IS_JSON_AVAILABLE) {
            e.preventDefault();
        }
        this.IS_JSON_AVAILABLE = false;
        Util.DelDomValidateError();
    }


    handleSuccess(e) {
        if(e.target.name !== this.NEW_EDIT_FORM_NAME) {
           return;
        }
        const detail = e.detail[0];
        if(detail != null && detail !== '') {
            Cookie.Set(this.CONFIG.COOKIE_NAME_NOTIFICATION, detail, 86400, new URL(this.CONFIG.URL_COMPLAINTS).pathname, window.location.protocol === 'https', 'Strict');
        }
        location.href = this.CONFIG.URL_COMPLAINTS + '/' + this.NEW_EDIT_FORM_STORE_ID.value;
    }


    handleError(e) {
        if(e.target.name !== this.NEW_EDIT_FORM_NAME) {
           return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0)
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        const valid = detail.valid;
        if(msg != null && msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
        if(valid != null) {
            if(valid['shop_id'] != null && valid['shop_id'][0] != null) {
                Util.GenDomValidateError(this.NEW_EDIT_FORM_SHOP_ID, valid['shop_id'][0]);
            }
//            if(valid['deadline'] != null && valid['deadline'][0] != null) {
//                Util.GenDomValidateError(this.NEW_EDIT_FORM_DEADLINE, valid['deadline'][0]);
//            }
            if(valid['status_classification'] != null && valid['status_classification'][0] != null) {
                Util.GenDomValidateError(this.NEW_EDIT_FORM_STATUS_CLASSIFICATION, valid['status_classification'][0]);
            }
            if(valid['status'] != null && valid['status'][0] != null) {
                Util.GenDomValidateError(this.NEW_EDIT_FORM_STATUS, valid['status'][0]);
            }
            if(valid['username'] != null && valid['username'][0] != null) {
                Util.GenDomValidateError(this.NEW_EDIT_FORM_USERNAME, valid['username'][0]);
            }
            if(valid['complaint_contacts.inquiry_date'] != null && valid['complaint_contacts.inquiry_date'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_INQUIRY_DATE_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '') {
                        Util.GenDomValidateError(elms[i], valid['complaint_contacts.inquiry_date'][0]);
                    }
                }
            }
            if(valid['complaint_contacts.inquiry_source_type'] != null && valid['complaint_contacts.inquiry_source_type'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_INQUIRY_SOURCE_TYPE_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '') {
                        Util.GenDomValidateError(elms[i], valid['complaint_contacts.inquiry_source_type'][0]);
                    }
                }
            }
            if(valid['complaint_contacts.contacts'] != null && valid['complaint_contacts.contacts'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_CONTACTS_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '' || elms[i].value.length > 500) {
                        Util.GenDomValidateError(elms[i], valid['complaint_contacts.contacts'][0]);
                    }
                }
            }
            if(valid['complaint_transactions.card_number_prefix'] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_CARD_NUMBER_PREFIX_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value !== '' && !/[0-9*]{6}/.test(elms[i].value)) {
                        if(elms[i].type !== "hidden") {
                            Util.GenDomValidateError(elms[i], valid['complaint_transactions.card_number_prefix'][0]);
                        }
                    }
                }
            }
            if(valid['complaint_transactions.card_number_suffix'] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_CARD_NUMBER_SUFFIX_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '' || !/[0-9]{4}/.test(elms[i].value)) {
                        if(elms[i].type !== "hidden") {
                            Util.GenDomValidateError(elms[i], valid['complaint_transactions.card_number_suffix'][0]);
                        }
                    }
                }
            }
            if(valid['complaint_transactions.transaction_code'] != null && valid['complaint_transactions.transaction_code'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_TRANSACTION_CODE_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '' || elms[i].value.length > 100) {
                        Util.GenDomValidateError(elms[i], valid['complaint_transactions.transaction_code'][0]);
                    }
                }
            }
            if(valid['complaint_transactions.transaction_date'] != null && valid['complaint_transactions.transaction_date'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_TRANSACTION_DATE_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '') {
                        Util.GenDomValidateError(elms[i], valid['complaint_transactions.transaction_date'][0]);
                    }
                }
            }
            if(valid['complaint_transactions.amount'] != null && valid['complaint_transactions.amount'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_AMOUNT_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '' || elms[i].value > 9999999.99 || !/^([0-9\.]*)$/.test(elms[i].value)) {
                        Util.GenDomValidateError(elms[i], valid['complaint_transactions.amount'][0]);
                    }
                }
            }
            if(valid['complaint_transactions.brand_id'] != null && valid['complaint_transactions.brand_id'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_BRAND_ID_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '') {
                        Util.GenDomValidateError(elms[i], valid['complaint_transactions.brand_id'][0]);
                    }
                }
            }
            if(valid['complaint_transactions.action_required_flag'] != null && valid['complaint_transactions.action_required_flag'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_ACTION_REQUIRED_FLAG_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '') {
                        Util.GenDomValidateError(elms[i], valid['complaint_transactions.action_required_flag'][0]);
                    }
                }
            }

            if(valid['complaint_contents.content'] != null && valid['complaint_contents.content'][0] != null) {
                const elms =  this.NEW_EDIT_FORM.querySelectorAll('[data="' + this.NEW_EDIT_FORM_CONTENT_DATASET + '"]');
                for(let i = 0; i < elms.length; i++) {
                    if(elms[i].value === '' || elms[i].value.length > 500) {
                        Util.GenDomValidateError(elms[i], valid['complaint_contents.content'][0]);
                    }
                }
            }
        }
        window.scrollTo(0, 0);
        this.JSON_HAS_MORE = false;
    }


    handleComplete(e) {
        if(e.target.name !== this.NEW_EDIT_FORM_NAME) {
           return;
        }
        this.IS_JSON_AVAILABLE = true;
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:before', (e) => { this.handleBefore(e) }, false);
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e) }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e) }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e) }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e) }, false);
    }



    handleAddContactsBtn() {
        const contactBox = document.getElementsByClassName(this.NEW_EDIT_FORM_CONTACTS_BOX_CLASS_NAME);
        const index = parseInt(document.getElementById(this.CONTACT_INDEX_ELM_ID).value);
        document.getElementById(this.CONTACT_INDEX_ELM_ID).value = index + 1;

        const clone = contactBox[0].cloneNode(true);
        const inquiryDateLabel = clone.querySelector('label[data="inquiry_date_label"]');
        const inquiryDateField = clone.querySelector('input[data="inquiry_date_field"]');
        const inquirySourceTypeLabel = clone.querySelector('label[data="inquiry_source_type_label"]');
        const inquirySourceTypeField = clone.querySelector('select[data="inquiry_source_type_field"]');
        const contactsLabel = clone.querySelector('label[data="contacts_label"]');
        const contactsTextarea = clone.querySelector('textarea');
        const button = clone.querySelector('button');
        inquiryDateLabel.setAttribute('for', inquiryDateLabel.getAttribute('for').replace('0', index));
        inquiryDateField.setAttribute('id', inquiryDateField.getAttribute('id').replace('0', index));
        inquiryDateField.name = inquiryDateField.name.replace('0', index);
        inquiryDateField.value = '';
        inquirySourceTypeLabel.setAttribute('for', inquirySourceTypeLabel.getAttribute('for').replace('0', index));
        inquirySourceTypeField.setAttribute('id', inquirySourceTypeField.getAttribute('id').replace('0', index));
        inquirySourceTypeField.name = inquirySourceTypeField.name.replace('0', index);
        inquirySourceTypeField.value = '';
        contactsLabel.setAttribute('for', contactsLabel.getAttribute('for').replace('0', index));
        contactsTextarea.setAttribute('id', contactsTextarea.getAttribute('id').replace('0', index));
        contactsTextarea.name = contactsTextarea.name.replace('0', index);
        contactsTextarea.value = '';
        button.classList.remove('d-none');
        button.addEventListener('click', () => { clone.remove(); }, false);
        const invalidFeedbacks = clone.getElementsByClassName('invalid-feedback');
        while(invalidFeedbacks.length > 0) {
            const o = invalidFeedbacks[0];
            o.previousElementSibling.classList.remove('is-invalid');
            o.remove();
        }
        contactBox[0].parentElement.appendChild(clone);
    }


    handleAddContentsBtn() {
        const contentBox = document.getElementsByClassName(this.NEW_EDIT_FORM_CONTENTS_BOX_CLASS_NAME);
        const index = parseInt(document.getElementById(this.CONTENT_INDEX_ELM_ID).value);
        document.getElementById(this.CONTENT_INDEX_ELM_ID).value = index + 1;

        const clone = contentBox[0].cloneNode(true);
        const contentLabel = clone.querySelector('label[data="contents_label"]');
        const contentTextarea = clone.querySelector('textarea');
        const button = clone.querySelector('button');
        contentLabel.setAttribute('for', contentLabel.getAttribute('for').replace('0', index));
        contentTextarea.setAttribute('id', contentTextarea.getAttribute('id').replace('0', index));
        contentTextarea.removeAttribute('readOnly');
        contentTextarea.name = contentTextarea.name.replace('0', index);
        contentTextarea.value = '';
        button.classList.remove('d-none');
        button.addEventListener('click', () => { clone.remove(); }, false);
        const invalidFeedbacks = clone.getElementsByClassName('invalid-feedback');
        while(invalidFeedbacks.length > 0) {
            const o = invalidFeedbacks[0];
            o.previousElementSibling.classList.remove('is-invalid');
            o.remove();
        }
        const dateElems = clone.getElementsByClassName("complaint_contents_date");
        while(dateElems.length > 0) {
            const o = dateElems[0];
            o.remove();
        }
        contentBox[0].parentElement.appendChild(clone);
    }


    handleAddTransactionAreaBtn() {
        const transactionAreaBox = document.getElementsByClassName(this.NEW_EDIT_FORM_TRANSACTION_AREA_CLASS_NAME);
        const index = parseInt(document.getElementById(this.TRANSACTION_INDEX_ELM_ID).value);
        document.getElementById(this.TRANSACTION_INDEX_ELM_ID).value = index + 1;

        const clone = transactionAreaBox[0].cloneNode(true);
        let transactionsBox = clone.getElementsByClassName(this.NEW_EDIT_FORM_TRANSACTIONS_BOX_CLASS_NAME);
        for(let i = transactionsBox.length - 1; i > 0; i--) {
            transactionsBox[i].remove();
        }
        this.resetTransactionsBox(transactionsBox[0], index);
        const cardNumberPrefixFieldElm = transactionsBox[0].querySelector('input[data="card_number_prefix_field"]');
        if(cardNumberPrefixFieldElm !== null) cardNumberPrefixFieldElm.remove();
        const cardNumberSuffixFieldElm = transactionsBox[0].querySelector('input[data="card_number_suffix_field"]');
        if(cardNumberSuffixFieldElm !== null) cardNumberSuffixFieldElm.remove();

        const cardNumberPrefixLabel = clone.querySelector('label[data="card_number_prefix_label"]');
        const cardNumberPrefixField = clone.querySelector('input[data="card_number_prefix_field"]');
        const cardNumberSuffixLabel = clone.querySelector('label[data="card_number_suffix_label"]');
        const cardNumberSuffixField = clone.querySelector('input[data="card_number_suffix_field"]');

        cardNumberPrefixLabel.setAttribute('for', cardNumberPrefixLabel.getAttribute('for').replace('0', index));
        cardNumberPrefixField.setAttribute('id', cardNumberPrefixField.getAttribute('id').replace('0', index));
        cardNumberPrefixField.name = cardNumberPrefixField.name.replace('0', index);
        cardNumberPrefixField.value = '';
        cardNumberPrefixField.addEventListener('change', (e) => { this.reflectCardValue(e.target); }, false);

        cardNumberSuffixLabel.setAttribute('for', cardNumberSuffixLabel.getAttribute('for').replace('0', index));
        cardNumberSuffixField.setAttribute('id', cardNumberSuffixField.getAttribute('id').replace('0', index));
        cardNumberSuffixField.name = cardNumberSuffixField.name.replace('0', index);
        cardNumberSuffixField.value = '';
        cardNumberSuffixField.addEventListener('change', (e) => { this.reflectCardValue(e.target); }, false);

        clone.querySelector('button[data="deleteTransactionCardsBtn"]').addEventListener('click', (e) => {
            e.target.parentElement.parentElement.parentElement.parentElement.parentElement.remove();
        }, false);
        clone.querySelector('button[data="deleteTransactionCardsBtn"]').classList.remove('d-none');
        clone.querySelector('button[data="deleteTransactionsBtn"]').classList.add('d-none');
        clone.querySelector('button[name="addTransactionsBtn"]').addEventListener('click', () => { this.handleAddTransactionsBtn(); }, false);

        const hiddenIdPattern = /^complaint_complaint_transactions_attributes_\d{1,}_id$/g;
        const children = clone.children;
        for(let i = children.length - 1; i >= 0; i--) {
            if(children[i].tagName === "INPUT" && children[i].type === "hidden" && children[i].id.match(hiddenIdPattern) !== undefined) {
                children[i].remove();
            }
        }

        event.target.parentElement.parentElement.appendChild(clone);
    }

    reflectCardValue(elm) {
        const prefixValue = elm.parentElement.parentElement.parentElement.parentElement.querySelector('input[data="card_number_prefix_field"]').value;
        const suffixValue = elm.parentElement.parentElement.parentElement.parentElement.querySelector('input[data="card_number_suffix_field"]').value;
        const complaintTransactionsBox = elm.parentElement.parentElement.parentElement.parentElement.parentElement.getElementsByClassName(this.NEW_EDIT_FORM_TRANSACTIONS_BOX_CLASS_NAME);
        const boxCnt = complaintTransactionsBox.length;
        for(let i = 1; i < boxCnt; i++) {
            complaintTransactionsBox[i].querySelector('input[data="card_number_prefix_field"]').setAttribute('value', prefixValue);
            complaintTransactionsBox[i].querySelector('input[data="card_number_suffix_field"]').setAttribute('value', suffixValue);
        }
    }


    resetTransactionsBox(obj, index) {
        const prefixHidden = document.createElement('INPUT');
        prefixHidden.id = "complaint_complaint_transactions_attributes_0_card_number_prefix".replace('0', index);
        prefixHidden.name = "complaint[complaint_transactions_attributes][0][card_number_prefix]".replace('0', index);
        prefixHidden.setAttribute('type', "hidden");
        prefixHidden.setAttribute('data', "card_number_prefix_field");
        const suffixHidden = document.createElement('INPUT');
        suffixHidden.id = "complaint_complaint_transactions_attributes_0_card_number_suffix".replace('0', index);
        suffixHidden.name = "complaint[complaint_transactions_attributes][0][card_number_suffix]".replace('0', index);
        suffixHidden.setAttribute('type', "hidden");
        suffixHidden.setAttribute('data', "card_number_suffix_field");
        obj.appendChild(prefixHidden);
        obj.appendChild(suffixHidden);

        const transactionCodeLabel = obj.querySelector('label[data="transaction_code_label"]');
        const transactionCodeField = obj.querySelector('input[data="transaction_code_field"]');
        const transactionDateLabel = obj.querySelector('label[data="transaction_date_label"]');
        const transactionDateField = obj.querySelector('input[data="transaction_date_field"]');
        const amountLabel = obj.querySelector('label[data="amount_label"]');
        const amountField = obj.querySelector('input[data="amount_field"]');
        const brandIdLabel = obj.querySelector('label[data="brand_id_label"]');
        const brandIdField = obj.querySelector('select[data="brand_id_field"]');
        const button = obj.querySelector('button');
        transactionCodeLabel.setAttribute('for', transactionCodeLabel.getAttribute('for').replace('0', index));
        transactionCodeField.setAttribute('id', transactionCodeField.getAttribute('id').replace('0', index));
        transactionCodeField.name = transactionCodeField.name.replace('0', index);
        transactionCodeField.value = '';
        transactionDateLabel.setAttribute('for', transactionDateLabel.getAttribute('for').replace('0', index));
        transactionDateField.setAttribute('id', transactionDateField.getAttribute('id').replace('0', index));
        transactionDateField.name = transactionDateField.name.replace('0', index);
        transactionDateField.value = '';
        amountLabel.setAttribute('for', amountLabel.getAttribute('for').replace('0', index));
        amountField.setAttribute('id', amountField.getAttribute('id').replace('0', index));
        amountField.name = amountField.name.replace('0', index);
        amountField.value = '';
        brandIdLabel.setAttribute('for', brandIdLabel.getAttribute('for').replace('0', index));
        brandIdField.setAttribute('id', brandIdField.getAttribute('id').replace('0', index));
        brandIdField.name = brandIdField.name.replace('0', index);
        brandIdField.value = '';
        button.classList.remove('d-none');
        button.setAttribute('data', "deleteTransactionsBtn");
        button.addEventListener('click', () => { obj.remove(); }, false);
        const invalidFeedbacks = obj.getElementsByClassName('invalid-feedback');
        while(invalidFeedbacks.length > 0) {
            const o = invalidFeedbacks[0];
            o.previousElementSibling.classList.remove('is-invalid');
            o.remove();
        }
        this.AMOUNT_FORMATTER.AddInput(amountField);

        return obj;
    }

    handleAddTransactionsBtn() {
        const transactionBox = document.getElementsByClassName(this.NEW_EDIT_FORM_TRANSACTIONS_BOX_CLASS_NAME);
        const index = parseInt(document.getElementById(this.TRANSACTION_INDEX_ELM_ID).value);
        document.getElementById(this.TRANSACTION_INDEX_ELM_ID).value = index + 1;

        let clone = transactionBox[0].cloneNode(true);
        clone = this.resetTransactionsBox(clone, index)
        event.target.parentElement.parentElement.parentElement.parentElement.parentElement.appendChild(clone);
        this.reflectCardValue(event.target);
    }


    handleImage(e) {
        const tmpFiles = new Array();
        const files = e.target.files;
        const children = this.NEW_EDIT_FORM_FILES_BOX.children;
        if(children.length + files.length > this.FILE_MAX_NUM) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger('アップロードできるファイル数は ' + this.FILE_MAX_NUM + ' ファイルまでです。'), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0, 0);
            return;
        }
        for(let i = 0; i < files.length; i++) {
            const f = e.target.files[i];
            f.tmpId = f.name + f.size;
            if(f.size > this.FILE_MAX_SIZE) {
                this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(f.name + 'は' + this.FILE_MAX_SIZE / 1000000 + 'MBを超えているため、アップロードできません。'), this.CONFIG.APP_MAIN.childNodes[0]);
                window.scrollTo(0, 0);
                continue;
            }
            tmpFiles.push(f);
        }
        while(tmpFiles.length > 0) {
            const f = tmpFiles.shift();
            this.UPLOAD_FILES.push(f);
            const fileReader = new FileReader();
            fileReader.onload = (ee) => {
                const fragment = document.createDocumentFragment();
                const div = document.createElement('DIV');
                div.dataset.tmpId = f.name + f.size;
                div.classList.add('col-xl-3', 'col-lg-3', 'col-md-6', 'col-sm-6', 'position-relative', 'mb-5');
                fragment.appendChild(div);
                const img = document.createElement('IMG');
                img.classList.add('d-block', 'w-100');
                if(f.type.indexOf('image/') !== -1) {
                    img.src = ee.target.result;
                } else {
                    img.src = this.NEW_EDIT_FORM_NO_IMAGE.src;
                }
                div.appendChild(img);
                const p = document.createElement('P');
                p.classList.add('text-muted');
                p.textContent = f.name;
                div.appendChild(p);
                const downloadBtn = document.createElement('BUTTON');
                downloadBtn.type = 'button';
                downloadBtn.classList.add('btn', 'btn-success', 'd-block', 'm-auto');
                downloadBtn.textContent = 'ダウンロード';
                downloadBtn.addEventListener('click', () => {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.download = f.name;
                    a.href = ee.target.result;
                    a.click();
                    a.remove();
                }, false);
                div.appendChild(downloadBtn);
                const closeBtn = document.createElement('BUTTON');
                closeBtn.dataset.tmp = f.name + f.size;
                closeBtn.type = 'button';
                closeBtn.classList.add('position-absolute', 'rounded-circle', 'bg-white');
                closeBtn.style.top = '-10px';
                closeBtn.style.right = '-10px';
                closeBtn.style.height = '48px';
                closeBtn.style.width = '48px';
                closeBtn.setAttribute('aria-label', 'Close');
                closeBtn.innerHTML = '<span aria-hidden="true">&times;</span>';
                div.appendChild(closeBtn);
                closeBtn.addEventListener('click', () => { div.remove(); }, false);
                this.NEW_EDIT_FORM_FILES_BOX.appendChild(fragment);
            }
            fileReader.readAsDataURL(f);
        }
    }


    setUpClickEventListener() {
        this.NEW_EDIT_FORM_ADD_CONTACTS_BTN.addEventListener('click', () => { this.handleAddContactsBtn(); }, false);
        this.NEW_EDIT_FORM_ADD_CONTENTS_BTN.addEventListener('click', () => { this.handleAddContentsBtn(); }, false);
        this.NEW_EDIT_FORM_ADD_TRANSACTION_CARDS_BTN.addEventListener('click', () => { this.handleAddTransactionAreaBtn(); }, false);
        const transactionCardElms = document.getElementsByName("addTransactionsBtn");
        const transactionCardCnt = transactionCardElms.length;
        for(let i = 0; i < transactionCardCnt; i++) {
            transactionCardElms[i].addEventListener('click', () => { this.handleAddTransactionsBtn(); }, false);
        }
    }


    setUpChangeEventListener() {
        this.NEW_EDIT_FORM_IMAGE.addEventListener('change', (e) => { this.handleImage(e); }, false);
    }


    setUpFormDataEventListener() {
        this.NEW_EDIT_FORM.addEventListener('formdata', (e) => {
            for(let i = 0; i < this.TMP_DELETE_FILES.length; i++) {
                e.formData.append('complaint[delete_files][]', this.TMP_DELETE_FILES[i]);
            }

            const children = this.NEW_EDIT_FORM_FILES_BOX.children;
            if(children.length === 0) {
                return;
            }
            for(let i = 0; i < children.length; i++) {
                for(let j = 0; j < this.UPLOAD_FILES.length; j++) {
                    if(children[i].dataset.tmpId === this.UPLOAD_FILES[j].tmpId) {
                        e.formData.append('complaint[upload_files][]', this.UPLOAD_FILES[j], this.UPLOAD_FILES[j].name)
                        break;
                    }
                }
            }
        }, false);
    }


    init() {
        document.getElementById(this.CONTACT_INDEX_ELM_ID).value = document.getElementsByClassName(this.NEW_EDIT_FORM_CONTACTS_BOX_CLASS_NAME).length;
        document.getElementById(this.TRANSACTION_INDEX_ELM_ID).value = document.getElementsByClassName(this.NEW_EDIT_FORM_TRANSACTIONS_BOX_CLASS_NAME).length;
        document.getElementById(this.CONTENT_INDEX_ELM_ID).value = document.getElementsByClassName(this.NEW_EDIT_FORM_CONTENTS_BOX_CLASS_NAME).length;

        const deleteContactBtns = document.querySelectorAll(this.NEW_EDIT_FORM_CONTACTS_DELETE_BTN_QUERY_SELECTOR);
        if(deleteContactBtns != null && deleteContactBtns.length > 0) {
            for(let i = 0; i < deleteContactBtns.length; i++) {
                deleteContactBtns[i].addEventListener('click', () => {
                    deleteContactBtns[i].parentElement.parentElement.parentElement.remove();
                }, false);
            }
        }

        const deleteTransactionBtns = document.querySelectorAll(this.NEW_EDIT_FORM_TRANSACTIONS_DELETE_BTN_QUERY_SELECTOR);
        if(deleteTransactionBtns != null && deleteTransactionBtns.length > 0) {
            for(let i = 0; i < deleteTransactionBtns.length; i++) {
                deleteTransactionBtns[i].addEventListener('click', () => {
                    deleteTransactionBtns[i].parentElement.parentElement.parentElement.remove();
                }, false);
            }
        }

        const transactionCardBoxes = document.getElementsByClassName('complaintTransactionCardsBox');
        if(transactionCardBoxes != null && transactionCardBoxes.length > 0) {
            for(let i = 0; i < transactionCardBoxes.length; i++) {
                transactionCardBoxes[i].querySelector('input[data="card_number_prefix_field"]').addEventListener('change', (e) => {
                    this.reflectCardValue(e.target);
                }, false);
                transactionCardBoxes[i].querySelector('input[data="card_number_suffix_field"]').addEventListener('change', (e) => {
                    this.reflectCardValue(e.target);
                }, false);
            }
        }

        const deleteTransactionCardBtns = document.querySelectorAll(this.NEW_EDIT_FORM_TRANSACTION_CARDS_DELETE_BTN_QUERY_SELECTOR);
        if(deleteTransactionCardBtns != null && deleteTransactionCardBtns.length > 0) {
            for(let i = 1; i < deleteTransactionCardBtns.length; i++) {
                deleteTransactionCardBtns[i].addEventListener('click', () => {
                    deleteTransactionCardBtns[i].parentElement.parentElement.parentElement.parentElement.parentElement.remove();
                }, false);
            }
        }

        const deleteContentBtns = document.querySelectorAll(this.NEW_EDIT_FORM_CONTENTS_DELETE_BTN_QUERY_SELECTOR);
        if(deleteContentBtns != null && deleteContentBtns.length > 0) {
            for(let i = 0; i < deleteContentBtns.length; i++) {
                deleteContentBtns[i].addEventListener('click', () => {
                    deleteContentBtns[i].parentElement.parentElement.parentElement.remove();
                }, false);
            }
        }

        const uploadedFilesClose = document.querySelectorAll(this.NEW_EDIT_FORM_UPLOADED_FILES_CLOSE_QUERY_SELECTOR);
        if(uploadedFilesClose != null && uploadedFilesClose.length > 0) {
            for(let i = 0; i < uploadedFilesClose.length; i++) {
                uploadedFilesClose[i].addEventListener('click', () => {
                    const div = uploadedFilesClose[i].parentElement;
                    if(div == null || div.dataset.id == null || div.dataset.id === '') {
                        return;
                    }
                    this.TMP_DELETE_FILES.push(div.dataset.id);
                    div.remove();
                }, false);
            }
        }
        const uploadedFilesDownload = document.querySelectorAll(this.NEW_EDIT_FORM_UPLOADED_FILES_DOWNLOAD_QUERY_SELECTOR);
        if(uploadedFilesDownload != null && uploadedFilesDownload.length > 0) {
            for(let i = 0; i < uploadedFilesDownload.length; i++) {
                uploadedFilesDownload[i].addEventListener('click', () => {
                    const img = uploadedFilesDownload[i].parentElement.querySelector(this.NEW_EDIT_FORM_UPLOADED_FILES_DATA_QUERY_SELECTOR);
                    if(img == null) {
                        return;
                    }
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.download = img.dataset.name;
                    a.href = img.src;
                    a.click();
                    a.remove();
                }, false);
            } 
        }
    }


    Run() {
        this.setUpRailsUjsEventListener();
        this.setUpClickEventListener();
        this.setUpChangeEventListener();
        this.setUpFormDataEventListener();
        this.init();
        this.AMOUNT_FORMATTER.Run();
    }

}
export { NewEditForm }
